import React, { Component } from "react";
import axios from "axios";
import Router from "next/router";
import { SearchFeild, InText } from "../../components";
import Layout from "../../container";
// import Geocode from "react-geocode";
import { LandingGrids, LandingFooter } from "../../pagecomponents/Welcome";
import { gridData } from "../../pagecomponents/Welcome/landingData.json";
import {
  Divider,
  Segment,
  Grid,
  Container,
  Tab,
  Input,
  Icon,
  Modal,
  Button,
} from "semantic-ui-react";
import PlacesAutocomplete from "react-places-autocomplete";
// import Head from "next/head";
import cookie from "react-cookies";
import { getSearchNeighbors } from "../../modules/Graphql/neighboraddressserachgraphql";
import {
  getNHmaphomelist,
  MlslistingsAddressSuggestions,
} from "../../modules/Graphql/Nhmaphomegraphql";
import { getSchoolinNh } from "../../modules/Graphql/neighborhoodboundriesgraphql";
import { getUserVerificationStatus } from "../../modules/Graphql/usergraphql";
import { GridPDFExport } from "@progress/kendo-react-pdf";
var localStorage = require("localStorage");

import { Amplify, Auth } from "aws-amplify";
import CognitoConfig from "../../common/Cognitoconfig";
import Head from "../../components/head";
import FeedbackForm from "../../common/FeedbackForm";
// Amplify.configure(CognitoConfig);
function startsWithNumber(str) {
  return /^\d/.test(str);
}
const customStylesModal = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    // width: "90%",
    // overflow: "hidden",
    // margin: "0 auto",
    border: "none",
  },
};
class LandingPage extends Component {
  constructor() {
    super();
    this.resultarr = [];

    this.state = {
      places: [],
      address: "",
      query: "",
      nhresults: [],
      results: [],
      homeresults: [],
      loadingtext: "hidden",
      resindex: 5,
      displaydata: "hidden",
      activeSuggestion: 0,
      userInput: "",
      showSuggestions: false,
      address: "",
      newsuggestion_length: "",
      gmapsLoaded: false,
      first_record: true,
      isMobile: false,
      timer: null,
      ismodalOpen: false,
      verificationmsg: "",
      verificationstatus: "",
    };
    //this.handleAddressChange = this.handleAddressChange.bind(this);
    //  this.handleAddressSelect = this.handleAddressSelect.bind(this);
    // this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.initMapdata = this.initMapdata.bind(this);
    this.closeModalsucess = this.closeModalsucess.bind(this);
  }
  newsuggestion_length = 0;
  newsuggestions = [];
  closeModalsucess = () => {
    this.setState({ ismodalopen: false });
  };
  initMapdata = () => {
    this.setState({
      gmapsLoaded: true,
    });
  };

  modelcloseiconclick = () => {
    this.setState({ ismodalOpen: false });
  };
  handleWindowSizeChange = () => {
    this.setState({ isMobile: window.innerWidth <= 767 });
  };

  resize = () => this.forceUpdate();

  componentDidMount() {
    this.handleWindowSizeChange();

    window.addEventListener("resize", this.handleWindowSizeChange);

    let getcredentialchange = localStorage.getItem("credentialchange");
    if (getcredentialchange === "true") {
      setTimeout(() => {
        // document.getElementById("sign_in_btn").click();
        localStorage.setItem("credentialchange", "");
      }, 5000);
    }

    setTimeout(() => this.initMapdata(), 1500);
  }

  handleimageclick = () => {
    localStorage.setItem("ispagemain", false);
  };

  getInfo = (searchquery) => {
    const getdata = {
      start: 0,
      limit: 5,
      orderBy: "label",
      order: "ASC",
      fields: [
        {
          name: "label",
          value: searchquery,
          operator: "LIKE",
        },
      ],
    };

    getSearchNeighbors(getdata)
      .then((result) => {
        if (result.data.getSearchNeighbors.length === 0) {
          this.setState({ loading: "none" });
        }
        if (result.data.getSearchNeighbors.length > 0)
          this.setState({ loading: "none" });

        this.setState({
          nhresults: result.data.getSearchNeighbors,
        });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  getMlshomeInfo = (searchquery) => {
    this.setState({ is_loaded: false });
    const getdatamls = {
      address: searchquery,
    };
    MlslistingsAddressSuggestions(getdatamls)
      .then((result) => {
        this.setState({ activeSuggestion: 0 });
        this.setState({ is_loaded: true });
        let mlsresult = result.data.MlslistingsAddressSuggestions;
        if (mlsresult && mlsresult.length > 0) {
          const finalresultmls = [...this.state.results, ...mlsresult];
          this.setState({ results: finalresultmls });
        }
      })
      .catch((error) => {
        this.setState({ activeSuggestion: 0 });
        this.setState({ is_loaded: true });
        console.error(error);
      });
  };

  gethomedataInfo = (searchquery) => {
    this.setState({ is_loaded: false });
    if (searchquery !== "") {
      const getneighbordata = {
        start: 0,
        limit: 5,
        orderBy: "label",
        order: "ASC",
        fields: [
          {
            name: "label",
            value: searchquery,
            operator: "LIKE",
          },
        ],
      };
      const getdata = {
        start: 0,
        limit: 5,
        orderBy: "UnparsedAddress",
        order: "Like",
        fields: [
          {
            name: "UnparsedAddress",
            value: searchquery,
            operator: "LIKE",
          },
        ],
      };
      const getdatamls = {
        address: searchquery,
      };
      const getdataschool = {
        start: 0,
        limit: 5,
        orderBy: "School",
        order: "Like",
        fields: [
          {
            name: "School",
            value: searchquery,
            operator: "LIKE",
          },
        ],
      };

      Promise.all([
        getNHmaphomelist(getdata),
        getSearchNeighbors(getneighbordata),
        getSchoolinNh(getdataschool),
      ])
        .then((result) => {
          if (this.state.query === "") {
            this.setState({
              results: [],
              homeresults: [],
              is_suggestion_click: false,
              activeSuggestion: 0,
            });
            this.setState({ showSuggestions: false });
          } else {
            let righthomedata = [];

            if (
              result[0].data.getnhmaphome &&
              result[0].data.getnhmaphome !== null &&
              result[0].data.getnhmaphome.length > 0
            ) {
              righthomedata.push(...result[0].data.getnhmaphome);
            }
            this.setState({ homeresults: righthomedata });
            let homeresult = righthomedata;

            if (result[1].data.getSearchNeighbors.length === 0) {
              this.setState({ loading: "none" });
            }
            if (result[1].data.getSearchNeighbors.length > 0)
              this.setState({ loading: "none" });

            // this.setState({
            //   nhresults: result.data.getSearchNeighbors,
            // });
            let nhresultsdata = result[1].data.getSearchNeighbors;
            let schoolresultdata = result[2].data.getSchoolinNh;

            let finalresult = [
              ...nhresultsdata,
              ...homeresult,
              ...schoolresultdata,
            ];
            if (this.state.query !== "") {
              this.setState({
                results: finalresult,
              });
            }
          }
          if (!this.state.is_selected) {
            this.setState({ showSuggestions: true });
          }
        })

        .catch((error) => {
          this.setState({
            results: [],
            sctiveSuggestion: 0,
          });

          console.error(error);
        });
    } else {
      this.setState({
        results: [],
        homeresults: [],
        is_suggestion_click: false,
      });
      this.setState({ showSuggestions: false });
    }
    // getNHmaphomelist(getdata)
    //   .then((result) => {
    //     if (searchquery.length === 0) {
    //       this.setState({
    //         results: [],
    //         homeresults: [],
    //         is_suggestion_click: false,
    //       });
    //       this.setState({ showSuggestions: false });
    //     } else {
    //       this.setState({ homeresults: result.data.getnhmaphome });
    //       let homeresult = result.data.getnhmaphome;
    //       let finalresult = [...nhresultsdata, ...homeresult];
    //       this.setState({
    //         results: finalresult,
    //       });
    //     }
    //   })
    //   .catch((error) => {
    //     this.setState({
    //       results: nhresultsdata,
    //     });
    //     console.error(error);
    //   });
  };

  handleInputChange = (address) => {
    this.setState({ userInput: address });
    let searchquery = this.search.value;
    let searchdata = searchquery.replace(/[' ']/g, "%");

    this.setState({ address: address });

    this.setState(
      {
        query: searchquery,
      },
      () => {
        if (this.state.query && this.state.query.length >= 2) {
          this.setState({ loading: "block" });
          this.gethomedataInfo(searchquery);

          if (startsWithNumber(searchquery)) {
            this.getMlshomeInfo(searchquery);
          }
          // clearTimeout(this.state.timer);

          // const newTimer = setTimeout(() => {
          //this.getInfo(searchquery);
          //   this.gethomedataInfo(searchquery);
          // }, 500);
          // this.setState({ timer: newTimer });
        }

        if (this.state.query.length === 0) {
          this.setState({
            results: [],
          });
          this.setState({ showSuggestions: false });
          this.gethomedataInfo("");
        }
      }
    );
  };

  handleKeyChange = (e) => {
    this.setState({ first_record: true });
    const { activeSuggestion, results } = this.state;
    let userinputdata;
    let filterdarr = results.filter((x) => {
      if (x.label) {
        return (
          x.label.toLowerCase().indexOf(this.state.query.toLowerCase()) === 0
        );
      } else if (x.UnparsedAddress) {
        return (
          x.UnparsedAddress.toLowerCase().indexOf(
            this.state.query.toLowerCase()
          ) === 0
        );
      }
    });
    if (filterdarr.length > 0) {
      if (e.keyCode === 13) {
        this.setState({
          activeSuggestion: 0,
          showSuggestions: false,
          //  userInput: filterdarr[activeSuggestion].label,
        });
        let red_address = this.state.userInput;
        // if (
        //   filterdarr[activeSuggestion] !== undefined &&
        //   filterdarr[activeSuggestion].label &&
        //   filterdarr[activeSuggestion].label !== undefined
        // ) {
        //   red_address = filterdarr[activeSuggestion].label;
        // } else {
        //   red_address =
        //     filterdarr[activeSuggestion].UnparsedAddress +
        //     ", " +
        //     filterdarr[activeSuggestion].City +
        //     ", " +
        //     filterdarr[activeSuggestion].StateOrProvince +
        //     ", " +
        //     filterdarr[activeSuggestion].PostalCode;
        // }

        localStorage.setItem("ispagemain", true);
        window.location.replace("/?address=" + red_address);
      }

      // User pressed the up arrow, decrement the index
      else if (e.keyCode === 38) {
        let activesuggestiondata = activeSuggestion - 1;
        let mydiv = document.getElementById(activesuggestiondata);
        if (mydiv && mydiv !== null && mydiv !== undefined) {
          activesuggestiondata = activeSuggestion - 1;
          userinputdata =
            document.getElementById(activesuggestiondata).innerHTML;
          this.setState({ activeSuggestion: activeSuggestion - 1 });
          this.setState({
            userInput: userinputdata,
          });
        }
        this.setState({ is_suggestion_click: true });
      }

      // User pressed the down arrow, increment the index
      else if (e.keyCode === 40) {
        let activesuggestiondata = activeSuggestion + 1;
        let mydiv = document.getElementById(activesuggestiondata);
        if (mydiv && mydiv !== null && mydiv !== undefined) {
          activesuggestiondata = activeSuggestion + 1;
          userinputdata =
            document.getElementById(activesuggestiondata).innerHTML;
          this.setState({ activeSuggestion: activeSuggestion + 1 });
          this.setState({
            userInput: userinputdata,
          });
        }
        this.setState({ is_suggestion_click: true });
      }
    }
  };

  handleSelect = (e) => {
    this.setState({ userInput: e.currentTarget.innerText });
    let red_address = e.currentTarget.innerText;
    localStorage.setItem("ispagemain", true);
    window.location.replace("/?address=" + red_address);
  };

  handleOutsideClick = () => {
    if (this.state.showSuggestions === true) {
      this.setState({ showSuggestions: false });
    }
  };

  handleExplore = () => {
    window.location.replace("/?address=San Francisco, CA, USA");
  };

  render() {
    let urls;

    if (
      localStorage.getItem("redirecturl") &&
      localStorage.getItem("redirecturl") != null &&
      !localStorage.getItem("redirecturl").includes(null)
    ) {
      urls = localStorage.getItem("redirecturl");
    } else {
      urls = "/?address=San Francisco, CA, USA";
    }
    let { places, isMobile } = this.state;
    let loaderdisplay;
    if (this.state.loadingtext === "visible") {
      loaderdisplay = "block";
    } else {
      loaderdisplay = "none";
    }
    const searchOptions = {
      types: ["(regions)"],
    };
    const onError = (status, clearSuggestions) => {};
    let dataarr = [];
    const unique = [];
    let result = [];
    let count = 0;
    return (
      <div className="landing-wrapper">
        <Head
          title="Houseberry - Welcome"
          description="Find Your Neighborhood First. Then Your Home."
          ogImage={process.env.NEXT_PUBLIC_CDN_ID + "static/images/seoimg.png"}
        />

        <Layout tagline>
          <Segment
            basic
            className="landing"
            onClick={this.handleOutsideClick}
            style={{ paddingTop: 5, margin: 0 }}
          >
            {/* <InText size="large" name="Find your dream Neighborhood" color="blue"/>
          <Divider hidden/>
          <Divider hidden/> */}

            {/* )} */}
            <Grid>
              <Grid.Row style={{ padding: 0 }}>
                <Grid.Column
                  mobile={16}
                  tablet={16}
                  computer={16}
                  style={{ padding: 0 }}
                >
                  <div className="welcome_top_main">
                    <div
                      className="welcome_banner"
                      style={{
                        backgroundImage: isMobile
                          ? `url(${process.env.NEXT_PUBLIC_CDN_ID}static/images/hb_banner_new.png)`
                          : `url(${process.env.NEXT_PUBLIC_CDN_ID}static/images/hb_banner_new1.png)`,
                      }}
                    >
                      {/* <img src="/static/images/hb_welcome.png"/> */}
                      <div className="welcome_serach">
                        <Grid>
                          <Grid.Row columns={3} className="search-bar-section">
                            <Grid.Column
                              mobile={1}
                              tablet={5}
                              computer={5}
                              className="search-bar-section-start"
                            />
                            <Grid.Column
                              mobile={14}
                              tablet={6}
                              computer={6}
                              className="search-bar-section-middle"
                            >
                              <div className="home_search_main">
                                <p>
                                  Find Your Neighborhood First. Then Your Home.
                                </p>
                              </div>
                              {!isMobile && (
                                <div className="landing_grid_btm">
                                  <LandingGrids
                                    gridData={gridData}
                                    urls={urls}
                                  />
                                </div>
                              )}
                              <div className="search_welcome_main">
                                {this.state.gmapsLoaded === false && (
                                  <div>
                                    <div
                                      className="ui input"
                                      style={{ width: "100%" }}
                                    >
                                      <div
                                        className="ui large left icon input location-search-input"
                                        style={{ width: "100%" }}
                                      >
                                        <input
                                          type="text"
                                          icon="search"
                                          iconposition="left"
                                          style={{
                                            width: "100%",
                                            borderRadius: "0px",
                                          }}
                                          size="large"
                                          placeholder="Enter neighborhood, address or city"
                                          className="location-search-input"
                                        />
                                        <i
                                          aria-hidden="true"
                                          className="search icon"
                                        ></i>
                                      </div>
                                    </div>
                                  </div>
                                )}
                                {this.state.gmapsLoaded && (
                                  <PlacesAutocomplete
                                    value={this.state.userInput}
                                    onChange={this.handleInputChange}
                                    onSelect={this.handleAddressSelect}
                                    shouldFetchSuggestions={
                                      this.state.address.length > 1
                                    }
                                    onError={onError}
                                  >
                                    {({
                                      getInputProps,
                                      suggestions,
                                      getSuggestionItemProps,
                                      loading,
                                    }) => {
                                      return (
                                        <div>
                                          <div
                                            className="ui input"
                                            style={{ width: "100%" }}
                                          >
                                            <div
                                              className="ui large left icon input location-search-input"
                                              style={{ width: "100%" }}
                                            >
                                              <input
                                                type="text"
                                                icon="search"
                                                iconposition="left"
                                                style={{
                                                  width: "100%",
                                                  borderRadius: "0px",
                                                }}
                                                size="large"
                                                placeholder="Search..."
                                                {...getInputProps({
                                                  placeholder:
                                                    "Enter neighborhood, address or city",
                                                })}
                                                onKeyDown={(e) =>
                                                  this.handleKeyChange(e)
                                                }
                                                ref={(input) =>
                                                  (this.search = input)
                                                }
                                              />
                                              <i
                                                aria-hidden="true"
                                                className="search icon"
                                              ></i>
                                            </div>
                                            <div
                                              className="autocomplete-dropdown-container"
                                              style={{
                                                paddingLeft: "16px",
                                                width: "100%",
                                                position: "absolute",
                                                zIndex: 999,
                                                backgroundColor: "#ffffff",
                                                textAlign: "left",
                                                visibility: "hidden",
                                                top: 42,
                                              }}
                                            >
                                              {suggestions.map((suggestion) => {
                                                if (
                                                  suggestion.types.includes(
                                                    "premise"
                                                  ) ||
                                                  suggestion.types.includes(
                                                    "route"
                                                  ) ||
                                                  suggestion.types.includes(
                                                    "locality"
                                                  ) ||
                                                  suggestion.types.includes(
                                                    "street_address"
                                                  ) ||
                                                  suggestion.types.includes(
                                                    "university"
                                                  ) ||
                                                  suggestion.types.includes(
                                                    "school"
                                                  ) ||
                                                  suggestion.types.includes(
                                                    "postal_code"
                                                  )
                                                ) {
                                                  if (
                                                    suggestion.types.includes(
                                                      "postal_code"
                                                    )
                                                  ) {
                                                    this.state.results.push({
                                                      label:
                                                        suggestion
                                                          .formattedSuggestion
                                                          .mainText +
                                                        " " +
                                                        suggestion
                                                          .formattedSuggestion
                                                          .secondaryText,
                                                      _type: suggestion.types,
                                                    });
                                                  } else {
                                                    this.state.results.push({
                                                      label:
                                                        suggestion.description,
                                                      _type: suggestion.types,
                                                    });
                                                  }
                                                }
                                                let keys = ["label"];
                                                let setObj = new Set(); // create key value pair from array of array
                                                let finalval = "";
                                                this.newsuggestions =
                                                  this.state.results.reduce(
                                                    (acc, item) => {
                                                      if (
                                                        item.label !== undefined
                                                      ) {
                                                        let resArray =
                                                          item.label.split(",");
                                                        if (
                                                          resArray.length > 3
                                                        ) {
                                                          let poppedItem =
                                                            resArray.pop();
                                                          finalval =
                                                            resArray.toString();
                                                        } else {
                                                          finalval = item.label;
                                                        }
                                                      } else if (
                                                        item.UnparsedAddress !==
                                                        undefined
                                                      ) {
                                                        finalval =
                                                          item.UnparsedAddress;
                                                      }
                                                      if (
                                                        this.state
                                                          .showSuggestions &&
                                                        item._type ===
                                                          undefined &&
                                                        item.UnparsedAddress !==
                                                          undefined
                                                      ) {
                                                        dataarr.push({
                                                          name:
                                                            item.UnparsedAddress +
                                                            ", " +
                                                            item.City +
                                                            ", " +
                                                            item.StateOrProvince +
                                                            ", " +
                                                            item.PostalCode,
                                                          category: "address",
                                                          id: item.ListingKeyNumeric,
                                                        });
                                                      }
                                                      if (
                                                        this.state
                                                          .showSuggestions &&
                                                        item._type === undefined
                                                      ) {
                                                        dataarr.push({
                                                          name: item.label,
                                                          category:
                                                            "neighborhood",
                                                        });
                                                      }

                                                      if (
                                                        item._type &&
                                                        this.state
                                                          .showSuggestions &&
                                                        item._type.includes(
                                                          "postal_code"
                                                        )
                                                      ) {
                                                        dataarr.push({
                                                          name: item.label,
                                                          category: "zipcode",
                                                        });
                                                      }

                                                      if (
                                                        item._type &&
                                                        this.state
                                                          .showSuggestions &&
                                                        item._type.includes(
                                                          "locality"
                                                        )
                                                      ) {
                                                        dataarr.push({
                                                          name: item.label,
                                                          category: "locality",
                                                        });
                                                      }
                                                      if (
                                                        item._type &&
                                                        this.state
                                                          .showSuggestions &&
                                                        (item._type.includes(
                                                          "street_address"
                                                        ) ||
                                                          item._type.includes(
                                                            "premise"
                                                          ) ||
                                                          item._type.includes(
                                                            "route"
                                                          ))
                                                      ) {
                                                        dataarr.push({
                                                          name: item.label,
                                                          category:
                                                            "googleaddress",
                                                        });
                                                      }
                                                      if (
                                                        item._type &&
                                                        this.state
                                                          .showSuggestions &&
                                                        item._type.includes(
                                                          "university"
                                                        )
                                                      ) {
                                                        dataarr.push({
                                                          name: item.label,
                                                          category:
                                                            "university",
                                                        });
                                                      }
                                                      if (
                                                        this.state
                                                          .showSuggestions &&
                                                        item._type ===
                                                          undefined &&
                                                        item.School !==
                                                          undefined
                                                      ) {
                                                        let schoolname = "";

                                                        schoolname +=
                                                          item.School;
                                                        if (item.City) {
                                                          schoolname +=
                                                            ", " + item.City;
                                                        }
                                                        if (item.State) {
                                                          schoolname +=
                                                            ", " + item.State;
                                                        }

                                                        dataarr.push({
                                                          name: schoolname,
                                                          category: "school",
                                                          id: item.id,
                                                        });
                                                      }
                                                      // if (
                                                      //   item._type &&
                                                      //   this.state
                                                      //     .showSuggestions &&
                                                      //   item._type.includes(
                                                      //     "school"
                                                      //   )
                                                      // ) {
                                                      //   dataarr.push({
                                                      //     name: item.label,
                                                      //     category: "school",
                                                      //   });
                                                      // }
                                                      dataarr.length > 0 &&
                                                        dataarr.map((x) =>
                                                          unique.filter(
                                                            (a) =>
                                                              a.name == x.name
                                                          ).length > 0
                                                            ? null
                                                            : unique.push(x)
                                                        );

                                                      //check exaxct match
                                                      let filterdarr =
                                                        unique.filter(
                                                          (x) =>
                                                            x.name &&
                                                            x.name
                                                              .toLowerCase()
                                                              .indexOf(
                                                                this.state.query.toLowerCase()
                                                              ) === 0
                                                        );
                                                      result =
                                                        filterdarr.length > 0 &&
                                                        filterdarr.reduce(
                                                          function (r, a) {
                                                            r[a.category] =
                                                              r[a.category] ||
                                                              [];
                                                            r[a.category].push(
                                                              a
                                                            );
                                                            return r;
                                                          },
                                                          Object.create(null)
                                                        );
                                                      if (
                                                        !setObj.has(finalval)
                                                      ) {
                                                        setObj.add(
                                                          finalval,
                                                          item
                                                        );
                                                        acc.push(item);
                                                      }
                                                      return acc;
                                                    },
                                                    []
                                                  );

                                                const className =
                                                  suggestion.active
                                                    ? "suggestion-item--active"
                                                    : "suggestion-item";
                                                const style = suggestion.active
                                                  ? {
                                                      backgroundColor:
                                                        "#fafafa",
                                                      cursor: "pointer",
                                                      paddingTop: "5px",
                                                    }
                                                  : {
                                                      backgroundColor:
                                                        "#ffffff",
                                                      cursor: "pointer",
                                                      paddingTop: "5px",
                                                    };
                                                return (
                                                  <div>
                                                    <span>
                                                      {suggestion.description}
                                                    </span>
                                                  </div>
                                                );
                                              })}
                                            </div>
                                            {
                                              <div
                                                className="autocomplete-dropdown-container"
                                                style={{
                                                  width: "100%",
                                                  position: "absolute",
                                                  zIndex: 999,
                                                  backgroundColor: "#ffffff",
                                                  textAlign: "left",
                                                  top: 43,
                                                  borderLeft:
                                                    "1px solid rgb(200, 200, 200)",
                                                  borderRight:
                                                    "1px solid rgb(200, 200, 200)",
                                                  // borderColor: "currentcolor rgb(200, 200, 200) rgb(200, 200, 200)",
                                                  // borderStyle: "none solid solid",
                                                  borderRadius:
                                                    "0px 0px 4px 4px",
                                                  //visibility:"hidden"
                                                }}
                                              >
                                                {result &&
                                                  result.neighborhood &&
                                                  result.neighborhood.length >
                                                    0 &&
                                                  result.neighborhood.map(
                                                    (item, index) => {
                                                      count++;
                                                      return (
                                                        <>
                                                          {index === 0 && (
                                                            <div className="nh_search">
                                                              <Icon name="home" />{" "}
                                                              Neighborhood
                                                            </div>
                                                          )}
                                                          <p
                                                            className={
                                                              item.name ===
                                                              this.state
                                                                .userInput
                                                                ? "suggestion-active"
                                                                : ""
                                                            }
                                                            id={count}
                                                            onClick={(e) =>
                                                              this.handleSelect(
                                                                e
                                                              )
                                                            }
                                                            style={{
                                                              cursor: "pointer",
                                                              paddingLeft:
                                                                "16px",
                                                            }}
                                                          >
                                                            {item.name}
                                                          </p>
                                                          {index + 1 ===
                                                            result.neighborhood
                                                              .length && (
                                                            <div
                                                              style={{
                                                                borderBottom:
                                                                  "1px solid rgb(200, 200, 200)",
                                                              }}
                                                            ></div>
                                                          )}
                                                        </>
                                                      );
                                                    }
                                                  )}
                                                {result &&
                                                  result.zipcode &&
                                                  result.zipcode.length > 0 &&
                                                  result.zipcode.map(
                                                    (item, index) => {
                                                      count++;
                                                      return (
                                                        <>
                                                          {index === 0 && (
                                                            <div className="nh_search">
                                                              <Icon name="home" />{" "}
                                                              zipcode
                                                            </div>
                                                          )}
                                                          <p
                                                            className={
                                                              item.name ===
                                                              this.state
                                                                .userInput
                                                                ? "suggestion-active"
                                                                : ""
                                                            }
                                                            id={count}
                                                            onClick={(e) =>
                                                              this.handleSelect(
                                                                e
                                                              )
                                                            }
                                                            style={{
                                                              cursor: "pointer",
                                                              paddingLeft:
                                                                "16px",
                                                            }}
                                                          >
                                                            {item.name}
                                                          </p>
                                                          {index + 1 ===
                                                            result.zipcode
                                                              .length && (
                                                            <div
                                                              style={{
                                                                borderBottom:
                                                                  "1px solid rgb(200, 200, 200)",
                                                              }}
                                                            ></div>
                                                          )}
                                                        </>
                                                      );
                                                    }
                                                  )}

                                                {result &&
                                                  result.address &&
                                                  result.address.length > 0 &&
                                                  result.address.map(
                                                    (item, index) => {
                                                      count++;
                                                      return (
                                                        <>
                                                          {index === 0 && (
                                                            <div className="nh_search">
                                                              <Icon name="street view" />{" "}
                                                              Listing Addresses
                                                            </div>
                                                          )}
                                                          <p
                                                            className={
                                                              item.name ===
                                                              this.state
                                                                .userInput
                                                                ? "suggestion-active"
                                                                : ""
                                                            }
                                                            id={count}
                                                            onClick={(e) =>
                                                              this.handleSelect(
                                                                e
                                                              )
                                                            }
                                                            style={{
                                                              cursor: "pointer",
                                                              paddingLeft:
                                                                "16px",
                                                            }}
                                                          >
                                                            {item.name}
                                                          </p>
                                                          {index + 1 ===
                                                            result.address
                                                              .length && (
                                                            <div
                                                              style={{
                                                                borderBottom:
                                                                  "1px solid rgb(200, 200, 200)",
                                                              }}
                                                            ></div>
                                                          )}
                                                        </>
                                                      );
                                                    }
                                                  )}

                                                {result &&
                                                  result.locality &&
                                                  result.locality.length > 0 &&
                                                  result.locality.map(
                                                    (item, index) => {
                                                      count++;
                                                      return (
                                                        <>
                                                          {index === 0 && (
                                                            <div className="nh_search">
                                                              <Icon name="building" />{" "}
                                                              City
                                                            </div>
                                                          )}
                                                          <p
                                                            className={
                                                              item.name ===
                                                              this.state
                                                                .userInput
                                                                ? "suggestion-active"
                                                                : ""
                                                            }
                                                            id={count}
                                                            onClick={(e) =>
                                                              this.handleSelect(
                                                                e
                                                              )
                                                            }
                                                            style={{
                                                              cursor: "pointer",
                                                              paddingLeft:
                                                                "16px",
                                                            }}
                                                          >
                                                            {item.name}
                                                          </p>
                                                          {index + 1 ===
                                                            result.locality
                                                              .length && (
                                                            <div
                                                              style={{
                                                                borderBottom:
                                                                  "1px solid rgb(200, 200, 200)",
                                                              }}
                                                            ></div>
                                                          )}
                                                        </>
                                                      );
                                                    }
                                                  )}

                                                {result &&
                                                  result.university &&
                                                  result.university.length >
                                                    0 &&
                                                  result.university.map(
                                                    (item, index) => {
                                                      count++;
                                                      return (
                                                        <>
                                                          {index === 0 && (
                                                            <div className="nh_search">
                                                              <Icon name="university" />{" "}
                                                              University
                                                            </div>
                                                          )}
                                                          <p
                                                            className={
                                                              item.name ===
                                                              this.state
                                                                .userInput
                                                                ? "suggestion-active"
                                                                : ""
                                                            }
                                                            onClick={(e) =>
                                                              this.handleSelect(
                                                                e
                                                              )
                                                            }
                                                            id={count}
                                                            style={{
                                                              cursor: "pointer",
                                                              paddingLeft:
                                                                "16px",
                                                            }}
                                                          >
                                                            {item.name}
                                                          </p>
                                                          {index + 1 ===
                                                            result.university
                                                              .length && (
                                                            <div
                                                              style={{
                                                                borderBottom:
                                                                  "1px solid rgb(200, 200, 200)",
                                                              }}
                                                            ></div>
                                                          )}
                                                        </>
                                                      );
                                                    }
                                                  )}

                                                {result &&
                                                  result.school &&
                                                  result.school.length > 0 &&
                                                  result.school.map(
                                                    (item, index) => {
                                                      count++;
                                                      return (
                                                        <>
                                                          {index === 0 && (
                                                            <div className="nh_search">
                                                              <Icon name="graduation cap" />{" "}
                                                              School
                                                            </div>
                                                          )}
                                                          <p
                                                            className={
                                                              item.name ===
                                                              this.state
                                                                .userInput
                                                                ? "suggestion-active"
                                                                : ""
                                                            }
                                                            onClick={(e) =>
                                                              this.handleSelect(
                                                                e
                                                              )
                                                            }
                                                            id={count}
                                                            style={{
                                                              cursor: "pointer",
                                                              paddingLeft:
                                                                "16px",
                                                            }}
                                                          >
                                                            {item.name}
                                                          </p>
                                                        </>
                                                      );
                                                    }
                                                  )}

                                                {result &&
                                                  result.googleaddress &&
                                                  result.googleaddress.length >
                                                    0 &&
                                                  result.googleaddress.map(
                                                    (item, index) => {
                                                      count++;
                                                      return (
                                                        <>
                                                          {index === 0 && (
                                                            <div className="nh_search">
                                                              <Icon name="street view" />{" "}
                                                              All Addresses
                                                            </div>
                                                          )}
                                                          <p
                                                            className={
                                                              item.name ===
                                                              this.state
                                                                .userInput
                                                                ? "suggestion-active"
                                                                : ""
                                                            }
                                                            id={count}
                                                            onClick={(e) =>
                                                              this.handleSelect(
                                                                e
                                                              )
                                                            }
                                                            style={{
                                                              cursor: "pointer",
                                                              paddingLeft:
                                                                "16px",
                                                            }}
                                                          >
                                                            {item.name}
                                                          </p>
                                                          {index + 1 ===
                                                            result.googleaddress
                                                              .length && (
                                                            <div
                                                              style={{
                                                                borderBottom:
                                                                  "1px solid rgb(200, 200, 200)",
                                                              }}
                                                            ></div>
                                                          )}
                                                        </>
                                                      );
                                                    }
                                                  )}
                                              </div>
                                            }
                                          </div>
                                        </div>
                                      );
                                    }}
                                  </PlacesAutocomplete>
                                )}
                              </div>
                              <div className="home_search_btm">
                                <p>or</p>
                                <Button
                                  primary
                                  onClick={() => this.handleExplore()}
                                  // disabled={this.props.next}
                                >
                                  Just Explore
                                </Button>
                              </div>
                            </Grid.Column>

                            <Grid.Column
                              mobile={1}
                              tablet={5}
                              computer={5}
                              className="search-bar-section-end"
                            />
                          </Grid.Row>
                        </Grid>
                      </div>
                      {/* <div className="welcome_text">
                <h1>We help you find the house of your dream.</h1>
            </div> */}
                    </div>
                  </div>
                </Grid.Column>
              </Grid.Row>
            </Grid>
            {isMobile && (
              <Grid>
                <Grid.Row>
                  <Grid.Column>
                    <LandingGrids gridData={gridData} ispage="home" />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            )}
            <div className="wrapper_container">
              <div className="middle_content">
                <Grid>
                  <Grid.Row style={{ paddingBottom: 0 }}>
                    <Grid.Column>
                      <div className="home_top_txt">
                        <p>
                          Finding home is more than just finding a house. Find
                          your ideal neighborhood first, with Houseberry.
                        </p>
                        <p className="home_sub_txt">
                          Houseberry uses sophisticated algorithms to evaluate
                          and score neighborhoods based on what matters most to
                          homebuyers.
                        </p>
                      </div>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
                <Divider />
                <Grid>
                  <Grid.Row>
                    <Grid.Column mobile={16} tablet={16} computer={16}>
                      <div className="middle_banner_sec">
                        <a href={urls} title="Houseberry">
                          <img
                            src={`${process.env.NEXT_PUBLIC_CDN_ID}static/images/hb_banner_map.png`}
                            onClick={() => this.handleimageclick()}
                            title="Houseberry"
                            alt="Houseberry"
                          />
                        </a>
                      </div>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>

                <Divider hidden />
                <Divider hidden />
              </div>
            </div>

            <div className="welcome_serach welcome-search-bar">
              <h3>Find Your Neighborhood First. Then Your Home.</h3>
              <Grid>
                <Grid.Row
                  columns={3}
                  style={{ minHeight: "75px" }}
                  className="search-bar-section"
                >
                  <Grid.Column
                    mobile={1}
                    tablet={5}
                    computer={5}
                    className="search-bar-section-start"
                  />
                  <Grid.Column
                    mobile={14}
                    tablet={6}
                    computer={6}
                    className="search-bar-section-middle"
                  >
                    {this.state.gmapsLoaded && (
                      <PlacesAutocomplete
                        value={this.state.userInput}
                        onChange={this.handleInputChange}
                        onSelect={this.handleAddressSelect}
                        shouldFetchSuggestions={this.state.address.length > 1}
                        onError={onError}
                      >
                        {({
                          getInputProps,
                          suggestions,
                          getSuggestionItemProps,
                          loading,
                        }) => {
                          return (
                            <div>
                              <div
                                className="ui input"
                                style={{ width: "100%" }}
                              >
                                <div
                                  className="ui large left icon input location-search-input"
                                  style={{ width: "100%" }}
                                >
                                  <input
                                    type="text"
                                    icon="search"
                                    iconposition="left"
                                    style={{
                                      width: "100%",
                                      borderRadius: "0px",
                                    }}
                                    size="large"
                                    placeholder="Search..."
                                    {...getInputProps({
                                      placeholder:
                                        "Enter neighborhood, address or city",
                                    })}
                                    onKeyDown={(e) => this.handleKeyChange(e)}
                                    ref={(input) => (this.search = input)}
                                  />
                                  <i
                                    aria-hidden="true"
                                    className="search icon"
                                  ></i>
                                </div>
                                <div
                                  className="autocomplete-dropdown-container"
                                  style={{
                                    paddingLeft: "16px",
                                    width: "100%",
                                    position: "absolute",
                                    zIndex: 999,
                                    backgroundColor: "#ffffff",
                                    textAlign: "left",
                                    visibility: "hidden",
                                    top: 42,
                                  }}
                                >
                                  {suggestions.map((suggestion) => {
                                    if (
                                      suggestion.types.includes("premise") ||
                                      suggestion.types.includes("route") ||
                                      suggestion.types.includes("locality") ||
                                      suggestion.types.includes(
                                        "street_address"
                                      ) ||
                                      suggestion.types.includes("university") ||
                                      suggestion.types.includes("school") ||
                                      suggestion.types.includes("postal_code")
                                    ) {
                                      if (
                                        suggestion.types.includes("postal_code")
                                      ) {
                                        this.state.results.push({
                                          label:
                                            suggestion.formattedSuggestion
                                              .mainText +
                                            " " +
                                            suggestion.formattedSuggestion
                                              .secondaryText,
                                          _type: suggestion.types,
                                        });
                                      } else {
                                        this.state.results.push({
                                          label: suggestion.description,
                                          _type: suggestion.types,
                                        });
                                      }
                                    }
                                    let keys = ["label"];
                                    let setObj = new Set(); // create key value pair from array of array
                                    let finalval = "";
                                    this.newsuggestions =
                                      this.state.results.reduce((acc, item) => {
                                        if (item.label !== undefined) {
                                          let resArray = item.label.split(",");
                                          if (resArray.length > 3) {
                                            let poppedItem = resArray.pop();
                                            finalval = resArray.toString();
                                          } else {
                                            finalval = item.label;
                                          }
                                        } else if (
                                          item.UnparsedAddress !== undefined
                                        ) {
                                          finalval = item.UnparsedAddress;
                                        }
                                        if (
                                          this.state.showSuggestions &&
                                          item._type === undefined &&
                                          item.UnparsedAddress !== undefined
                                        ) {
                                          dataarr.push({
                                            name:
                                              item.UnparsedAddress +
                                              ", " +
                                              item.City +
                                              ", " +
                                              item.StateOrProvince +
                                              ", " +
                                              item.PostalCode,
                                            category: "address",
                                            id: item.ListingKeyNumeric,
                                          });
                                        }
                                        if (
                                          this.state.showSuggestions &&
                                          item._type === undefined
                                        ) {
                                          dataarr.push({
                                            name: item.label,
                                            category: "neighborhood",
                                          });
                                        }

                                        if (
                                          item._type &&
                                          this.state.showSuggestions &&
                                          item._type.includes("postal_code")
                                        ) {
                                          dataarr.push({
                                            name: item.label,
                                            category: "zipcode",
                                          });
                                        }

                                        if (
                                          item._type &&
                                          this.state.showSuggestions &&
                                          item._type.includes("locality")
                                        ) {
                                          dataarr.push({
                                            name: item.label,
                                            category: "locality",
                                          });
                                        }
                                        if (
                                          item._type &&
                                          this.state.showSuggestions &&
                                          (item._type.includes(
                                            "street_address"
                                          ) ||
                                            item._type.includes("premise") ||
                                            item._type.includes("route"))
                                        ) {
                                          dataarr.push({
                                            name: item.label,
                                            category: "googleaddress",
                                          });
                                        }
                                        if (
                                          item._type &&
                                          this.state.showSuggestions &&
                                          item._type.includes("university")
                                        ) {
                                          dataarr.push({
                                            name: item.label,
                                            category: "university",
                                          });
                                        }
                                        if (
                                          this.state.showSuggestions &&
                                          item._type === undefined &&
                                          item.School !== undefined
                                        ) {
                                          let schoolname = "";

                                          schoolname += item.School;
                                          if (item.City) {
                                            schoolname += ", " + item.City;
                                          }
                                          if (item.State) {
                                            schoolname += ", " + item.State;
                                          }

                                          dataarr.push({
                                            name: schoolname,
                                            category: "school",
                                            id: item.id,
                                          });
                                        }
                                        // if (
                                        //   item._type &&
                                        //   this.state
                                        //     .showSuggestions &&
                                        //   item._type.includes(
                                        //     "school"
                                        //   )
                                        // ) {
                                        //   dataarr.push({
                                        //     name: item.label,
                                        //     category: "school",
                                        //   });
                                        // }
                                        dataarr.length > 0 &&
                                          dataarr.map((x) =>
                                            unique.filter(
                                              (a) => a.name == x.name
                                            ).length > 0
                                              ? null
                                              : unique.push(x)
                                          );

                                        //check exaxct match
                                        let filterdarr = unique.filter(
                                          (x) =>
                                            x.name &&
                                            x.name
                                              .toLowerCase()
                                              .indexOf(
                                                this.state.query.toLowerCase()
                                              ) === 0
                                        );
                                        result =
                                          filterdarr.length > 0 &&
                                          filterdarr.reduce(function (r, a) {
                                            r[a.category] = r[a.category] || [];
                                            r[a.category].push(a);
                                            return r;
                                          }, Object.create(null));
                                        if (!setObj.has(finalval)) {
                                          setObj.add(finalval, item);
                                          acc.push(item);
                                        }
                                        return acc;
                                      }, []);

                                    const className = suggestion.active
                                      ? "suggestion-item--active"
                                      : "suggestion-item";
                                    const style = suggestion.active
                                      ? {
                                          backgroundColor: "#fafafa",
                                          cursor: "pointer",
                                          paddingTop: "5px",
                                        }
                                      : {
                                          backgroundColor: "#ffffff",
                                          cursor: "pointer",
                                          paddingTop: "5px",
                                        };
                                    return (
                                      <div>
                                        <span>{suggestion.description}</span>
                                      </div>
                                    );
                                  })}
                                </div>
                                {
                                  <div
                                    className="autocomplete-dropdown-container"
                                    style={{
                                      width: "100%",
                                      position: "absolute",
                                      zIndex: 999,
                                      backgroundColor: "#ffffff",
                                      textAlign: "left",
                                      top: 43,
                                      borderLeft:
                                        "1px solid rgb(200, 200, 200)",
                                      borderRight:
                                        "1px solid rgb(200, 200, 200)",
                                      // borderColor: "currentcolor rgb(200, 200, 200) rgb(200, 200, 200)",
                                      // borderStyle: "none solid solid",
                                      borderRadius: "0px 0px 4px 4px",
                                      //visibility:"hidden"
                                    }}
                                  >
                                    {result &&
                                      result.neighborhood &&
                                      result.neighborhood.length > 0 &&
                                      result.neighborhood.map((item, index) => {
                                        count++;
                                        return (
                                          <>
                                            {index === 0 && (
                                              <div className="nh_search">
                                                <Icon name="home" />{" "}
                                                Neighborhood
                                              </div>
                                            )}
                                            <p
                                              className={
                                                item.name ===
                                                this.state.userInput
                                                  ? "suggestion-active"
                                                  : ""
                                              }
                                              id={count}
                                              onClick={(e) =>
                                                this.handleSelect(e)
                                              }
                                              style={{
                                                cursor: "pointer",
                                                paddingLeft: "16px",
                                              }}
                                            >
                                              {item.name}
                                            </p>
                                            {index + 1 ===
                                              result.neighborhood.length && (
                                              <div
                                                style={{
                                                  borderBottom:
                                                    "1px solid rgb(200, 200, 200)",
                                                }}
                                              ></div>
                                            )}
                                          </>
                                        );
                                      })}

                                    {result &&
                                      result.zipcode &&
                                      result.zipcode.length > 0 &&
                                      result.zipcode.map((item, index) => {
                                        count++;
                                        return (
                                          <>
                                            {index === 0 && (
                                              <div className="nh_search">
                                                <Icon name="home" /> zipcode
                                              </div>
                                            )}
                                            <p
                                              className={
                                                item.name ===
                                                this.state.userInput
                                                  ? "suggestion-active"
                                                  : ""
                                              }
                                              id={count}
                                              onClick={(e) =>
                                                this.handleSelect(e)
                                              }
                                              style={{
                                                cursor: "pointer",
                                                paddingLeft: "16px",
                                              }}
                                            >
                                              {item.name}
                                            </p>
                                            {index + 1 ===
                                              result.zipcode.length && (
                                              <div
                                                style={{
                                                  borderBottom:
                                                    "1px solid rgb(200, 200, 200)",
                                                }}
                                              ></div>
                                            )}
                                          </>
                                        );
                                      })}

                                    {result &&
                                      result.address &&
                                      result.address.length > 0 &&
                                      result.address.map((item, index) => {
                                        count++;
                                        return (
                                          <>
                                            {index === 0 && (
                                              <div className="nh_search">
                                                <Icon name="street view" />{" "}
                                                Listing Addresses
                                              </div>
                                            )}
                                            <p
                                              className={
                                                item.name ===
                                                this.state.userInput
                                                  ? "suggestion-active"
                                                  : ""
                                              }
                                              id={count}
                                              onClick={(e) =>
                                                this.handleSelect(e)
                                              }
                                              style={{
                                                cursor: "pointer",
                                                paddingLeft: "16px",
                                              }}
                                            >
                                              {item.name}
                                            </p>
                                            {index + 1 ===
                                              result.address.length && (
                                              <div
                                                style={{
                                                  borderBottom:
                                                    "1px solid rgb(200, 200, 200)",
                                                }}
                                              ></div>
                                            )}
                                          </>
                                        );
                                      })}

                                    {result &&
                                      result.locality &&
                                      result.locality.length > 0 &&
                                      result.locality.map((item, index) => {
                                        count++;
                                        return (
                                          <>
                                            {index === 0 && (
                                              <div className="nh_search">
                                                <Icon name="building" /> City
                                              </div>
                                            )}
                                            <p
                                              className={
                                                item.name ===
                                                this.state.userInput
                                                  ? "suggestion-active"
                                                  : ""
                                              }
                                              id={count}
                                              onClick={(e) =>
                                                this.handleSelect(e)
                                              }
                                              style={{
                                                cursor: "pointer",
                                                paddingLeft: "16px",
                                              }}
                                            >
                                              {item.name}
                                            </p>
                                            {index + 1 ===
                                              result.locality.length && (
                                              <div
                                                style={{
                                                  borderBottom:
                                                    "1px solid rgb(200, 200, 200)",
                                                }}
                                              ></div>
                                            )}
                                          </>
                                        );
                                      })}

                                    {result &&
                                      result.university &&
                                      result.university.length > 0 &&
                                      result.university.map((item, index) => {
                                        count++;
                                        return (
                                          <>
                                            {index === 0 && (
                                              <div className="nh_search">
                                                <Icon name="university" />{" "}
                                                University
                                              </div>
                                            )}
                                            <p
                                              className={
                                                item.name ===
                                                this.state.userInput
                                                  ? "suggestion-active"
                                                  : ""
                                              }
                                              onClick={(e) =>
                                                this.handleSelect(e)
                                              }
                                              id={count}
                                              style={{
                                                cursor: "pointer",
                                                paddingLeft: "16px",
                                              }}
                                            >
                                              {item.name}
                                            </p>
                                            {index + 1 ===
                                              result.university.length && (
                                              <div
                                                style={{
                                                  borderBottom:
                                                    "1px solid rgb(200, 200, 200)",
                                                }}
                                              ></div>
                                            )}
                                          </>
                                        );
                                      })}
                                    {result &&
                                      result.school &&
                                      result.school.length > 0 &&
                                      result.school.map((item, index) => {
                                        count++;
                                        return (
                                          <>
                                            {index === 0 && (
                                              <div className="nh_search">
                                                <Icon name="graduation cap" />{" "}
                                                School
                                              </div>
                                            )}
                                            <p
                                              className={
                                                item.name ===
                                                this.state.userInput
                                                  ? "suggestion-active"
                                                  : ""
                                              }
                                              onClick={(e) =>
                                                this.handleSelect(e)
                                              }
                                              id={count}
                                              style={{
                                                cursor: "pointer",
                                                paddingLeft: "16px",
                                              }}
                                            >
                                              {item.name}
                                            </p>
                                          </>
                                        );
                                      })}
                                    {result &&
                                      result.googleaddress &&
                                      result.googleaddress.length > 0 &&
                                      result.googleaddress.map(
                                        (item, index) => {
                                          count++;
                                          return (
                                            <>
                                              {index === 0 && (
                                                <div className="nh_search">
                                                  <Icon name="street view" />{" "}
                                                  All Addresses
                                                </div>
                                              )}
                                              <p
                                                className={
                                                  item.name ===
                                                  this.state.userInput
                                                    ? "suggestion-active"
                                                    : ""
                                                }
                                                id={count}
                                                onClick={(e) =>
                                                  this.handleSelect(e)
                                                }
                                                style={{
                                                  cursor: "pointer",
                                                  paddingLeft: "16px",
                                                }}
                                              >
                                                {item.name}
                                              </p>
                                              {index + 1 ===
                                                result.googleaddress.length && (
                                                <div
                                                  style={{
                                                    borderBottom:
                                                      "1px solid rgb(200, 200, 200)",
                                                  }}
                                                ></div>
                                              )}
                                            </>
                                          );
                                        }
                                      )}
                                  </div>
                                }
                              </div>
                            </div>
                          );
                        }}
                      </PlacesAutocomplete>
                    )}
                  </Grid.Column>
                  <Grid.Column
                    mobile={1}
                    tablet={5}
                    computer={5}
                    className="search-bar-section-end"
                  />
                </Grid.Row>
              </Grid>
              <Modal
                open={this.state.ismodalOpen}
                size="tiny"
                style={customStylesModal}
              >
                <div>
                  <p
                    className={
                      this.state.verificationstatus === "error"
                        ? "verfication_msg_err"
                        : "verfication_msg_success"
                    }
                  >
                    {this.state.verificationmsg}
                  </p>
                </div>
              </Modal>
            </div>
          </Segment>
          <LandingFooter />
        </Layout>
        <FeedbackForm />
      </div>
    );
  }
}

export default LandingPage;
